import theme from '@styles/theme';
import { memo } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import styled from 'styled-components';

import Header from '@components/layout/Header';

import Login from '@pages/Login';
import FindEmail from '@pages/FindEmail';
import FindPassword from '@pages/FindPassword';
import Main from '@pages/Main';
import Dashboard from '@pages/Dashboard';
import Member from '@pages/Member';
import MemberStatus from '@pages/Member/Status';
import MemberStatusDetail from '@pages/Member/Status/Detail';
import Seceder from '@pages/Member/Seceder';
import Operation from '@pages/Operation';
import QrStatus from '@pages/Operation/QrStatus';
import ManageProduct from '@pages/Operation/ManageProduct';
import Policy from '@pages/Operation/Policy';
import CreatePolicy from '@pages/Operation/Policy/CreatePolicy';
import Setting from '@pages/Setting';
import SysopList from '@pages/Setting/Sysop';
import SysopDetail from '@pages/Setting/Sysop/Detail';
import Qr from '@pages/Setting/Qr';
import SystemLog from '@pages/Setting/SystemLog';

const LoggedOutRoutes = memo(() => (
    <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/find/email" element={<FindEmail />} />
        <Route path="/find/password" element={<FindPassword />} />
        <Route path="/*" element={<Navigate replace to="/" />} />
    </Routes>
));

const LoggedInRoutes = memo(() => {
    return (
        <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/member" element={<Member />}>
                <Route path="status" element={<MemberStatus />} />
                <Route
                    path="status/detail/:id"
                    element={<MemberStatusDetail />}
                />
                <Route path="secession" element={<Seceder />} />
            </Route>
            <Route path="/operation" element={<Operation />}>
                <Route path="qr" element={<QrStatus />} />
                <Route path="product" element={<ManageProduct />} />
                <Route path="policy" element={<Policy />} />
            </Route>
            <Route path="/operation/policy/new" element={<CreatePolicy />} />
            <Route path="/setting" element={<Setting />}>
                <Route path="sysop" element={<SysopList />} />
                <Route path="sysop/detail/:id" element={<SysopDetail />} />
                <Route path="qr" element={<Qr />} />
                <Route path="log" element={<SystemLog />} />
            </Route>
            <Route path="/*" element={<Navigate replace to="/" />} />
        </Routes>
    );
});

const Router = ({ isLoggedIn = true }: { isLoggedIn: boolean }) => {
    if (!isLoggedIn)
        return (
            <LoggedOutWrapper>
                <LoggedOutHeader>IT'S PET ADMIN</LoggedOutHeader>
                <LoggedOutRoutes />
            </LoggedOutWrapper>
        );

    return (
        <>
            <Header />
            <LoggedInRoutes />
        </>
    );
};

export default Router;

const LoggedOutWrapper = styled.div`
    width: 100vw;
    height: 100vh;
`;
const LoggedOutHeader = styled.header`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    font-size: 16px;
    font-family: PretendardMedium, sans-serif;
    border-bottom: ${theme.colors.ultraLightGrayBorder} 1px solid;
`;
